import RecommendedPortfolioList from "./RecommendedPortfolioList";
import Tooltip from "../Base/Tooltip";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    display: flex;
    align-items: center;
  }
`;

const RecommendedPortfolio = ({ portfolios, topHoldings }) => {
  return (
    <Wrapper>
      <div style={{ width: "20%" }}>
        <Header>
          <span className="title">Top Holdings:</span>
        </Header>
        <div>
          {topHoldings?.map((data, index) => (
            <div
              style={{ fontSize: "15px", marginTop: "10px", color: "black" }}
            >
              {index + 1}. {data}
            </div>
          ))}
        </div>
      </div>
      <div style={{ width: "80%" }}>
        <Header>
          <span className="title">
            Recommended Portfolio:
            <Tooltip text="Based on your goal and risk tolerance answers, the following personalized investment strategy has been identified. You can launch this model or select a new strategy mix." />
          </span>
        </Header>
        <RecommendedPortfolioList data={portfolios} />
      </div>
    </Wrapper>
  );
};

export default RecommendedPortfolio;
